// @ts-nocheck
import { IBoard, ICard, ILane } from '../components/kanbanBoard/models/BoardModel';
import { IPhaseModel } from '../models/PhaseModel';
import { IProjectModel } from '../models/ProjectModel';
import { IProjectTaskModel } from '../models/ProjectTaskModel';
import { sortTasks } from './TasksHelper';

export const sortProjectTasks = (project: IProjectModel, sortingType: number): void => {
  project.projectPhases.forEach((phase) => {
    sortTasks(phase.phaseTasks, sortingType);
  });
};

export const createBoardFromProject = (project: IProjectModel): IBoard<IProjectTaskModel> => {
  const board: IBoard<IProjectTaskModel> = {
    boardId: project.id,
    lanes: project.projectPhases.map((phase: IPhaseModel) => {
      return {
        id: phase.id.toString(),
        title: phase.phaseName,
        label: phase.id.toString(),
        cards: phase.phaseTasks.map((task: IProjectTaskModel) => {
          return {
            id: task.id,
            content: task,
          } as ICard<IProjectTaskModel>;
        }),
      } as ILane<IProjectTaskModel>;
    }),
  };
  return board;
};
